// extracted by mini-css-extract-plugin
export default {"caption":"Button_caption__JCCWu"};